import axios from "axios";
import { apis } from "../core/apis";
import * as appUtils from "../core/appUtils";

const { api } = apis;

const menuDataForBlue = [
    {
        tenantMenuName: "首页",
        path: "/"
    },
    {
        tenantMenuName: "我的培训",
        path: "/train"
    },
    {
        tenantMenuName: "我的档案",
        path: "/record"
    },
    {
        tenantMenuName: "课题列表",
        path: "/course"
    },
    {
        tenantMenuName: "我的订单",
        path: "/order"
    },
    {
        tenantMenuName: "申请发票",
        path: "/invoiceApply"
    },
    {
        tenantMenuName: "我的考试",
        path: "/myexam"
    },
    {
        tenantMenuName: "我的证书",
        path: "/certificate"
    }
];

export default {
    namespaced: true,
    state: () => {
        return {
            // 个人中心模式：0-纯远程培训 1-区平台
            personalMode: 0,
            // 全部菜单
            menuData: [],
            // 侧边菜单
            sidebarMenuData: [],
            // 顶部菜单额外激活规则
            activeRulesMap: {
                // 首页
                "/indexhd": ["/indexhd", "/myCertificate", "/record", "/order"],
                // 区级培训
                "/distcourseEnrollment": [
                    "/distcourseEnrollment",
                    "/distenrollmentRecords",
                    "/training",
                    "/audit1",
                    "/districtTrain",
                    "/districtRecord"
                ],
                // 校级培训
                "/courseEnrollment": [
                    "/courseEnrollment",
                    "/courseDeclaration",
                    "/enrollmentRecords",
                    "/gradeManagement",
                    "/queryStatistics",
                    "/groupSelecting",
                    "/audit",
                    "/selecting",
                    "/trainDeclaration",
                    "/addTrainDeclaration",
                    "/fundsManagement"
                ],
                // 科研课题
                "/listApply": [
                    "/listApply",
                    "/listApply2",
                    "/myManage",
                    "/applyDetail",
                    "/applySubjectChange"
                ],
                // 教研活动
                "/activityEnrollment": [
                    "/activityEnrollment",
                    "/activityRecords",
                    "/schoolBattleApplyDetail"
                ],
                // 遴选申报
                "/activitySelect": ["/activitySelect", "/activitySelect1","/districtCourseApply","/districtCourseRecord"]
            },
            // 侧边菜单额外激活规则
            sidebarMenuActiveRulesMap: {
                // 我的课程
                "/listApply": ["/applyDetail"],
                // 材料提交
                "/listApply2": ["/applyDetail1"],
                // 进行中活动
                "/activityEnrollment": ["/schoolBattleApplyDetail"]
            }
        };
    },
    mutations: {
        /**
         * 更新菜单配置
         * @param {*} state
         * @param {*} data 菜单数据
         */
        setMenuConfig(state, data) {
            const { menus, personalMode } = data;
            const isSchoolManager =
                appUtils.getUserInfo().x_isSchoolManager == "Y";
            state.personalMode = personalMode;
            if (isSchoolManager) {
                // 校管理员可使用全部功能
                state.menuData = menus;
            } else {
                // 过滤仅校管理员可见菜单
                const filter = list => {
                    return list.filter(item => {
                        if (item.is4admin === 1) {
                            return false;
                        }
                        if (item.children && item.children.length) {
                            item.children = filter(item.children);
                        }
                        return true;
                    });
                };
                state.menuData = filter(menus);
            }
        },
        /**
         * 更新
         * @param {*} state
         * @param {*} route 当前路由
         */
        updateSidebarMenuData(state, route) {
            const { personalMode, menuData, activeRulesMap } = state;
            if (personalMode === 1) {
                // 区平台：根据当前路由匹配侧边菜单
                for (let { path, children } of menuData) {
                    const activeRules = activeRulesMap[path];
                    if (activeRules && activeRules.includes(route.path)) {
                        state.sidebarMenuData = children;
                        break;
                    }
                }
            } else {
                // 纯远程培训只有两级菜单
                state.sidebarMenuData = menuData;
            }
        }
    },
    actions: {
        /**
         * 获取菜单配置
         * @param {*} context
         * @param {*} route 当前路由
         */
        getMenuConfig({ commit }, route) {
            const theme = appUtils.getAPPInfo().styleUsercentor;
            const appId = appUtils.getAppId();
            if (theme === "blue") {
                if (["APPY042", "APPY315"].includes(appId)) {
                    // 蓝色主题定制顶部菜单
                    commit("setMenuConfig", {
                        menus: menuDataForBlue,
                        personalMode: 1
                    });
                } else {
                    // 蓝色主题默认顶部菜单
                    commit("setMenuConfig", {
                        menus: menuDataForBlue.slice(0, 3),
                        personalMode: 1
                    });
                }
                return;
            }
            axios
                .get(api.common.getMenuConfig, {
                    params: { tenantCode: appId }
                })
                .then(res => {
                    const { status, data } = res;
                    if (status === 200) {
                        return data;
                    } else {
                        throw new Error(data.message);
                    }
                })
                .then(res => {
                    const { data } = res;
                    commit("setMenuConfig", data);
                    commit("updateSidebarMenuData", route);
                });
        }
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/menuConfig.js